export const LoadingFallback = () => {
  return (
    <div className="flex justify-center items-center py-20" role="status" aria-live="polite">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" aria-hidden="true"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
